import { render, staticRenderFns } from "./HomeExpertise.vue?vue&type=template&id=8748ba1e&"
import script from "./HomeExpertise.vue?vue&type=script&lang=js&"
export * from "./HomeExpertise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports